import React, { CSSProperties } from 'react';
import { Column } from 'react-table';
import Highlighter from 'react-highlight-words';
import { filter, any } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { searchByWords } from '../../../../common/helpers/searchHelper';
import { IQuestionWithOwner } from '../../../../common/models/question/IQuestionWithOwner';
import { getAttributeColors } from '../../../../common/helpers/colorHelper';

export const getColumns = (search: string): Column[] => [
  {
    accessor: 'text',
    Cell: ({ row: { original } }) => {
      const { lead, text } = original as IQuestionWithOwner;
      return (
        <div>
          <div className="rating-scale-hint">{lead}</div>
          <Highlighter
            highlightClassName="highlighted-text"
            className="overflow-ellipsis"
            searchWords={search.toLowerCase().split(' ')}
            textToHighlight={text}
            autoEscape
          />
        </div>
      );
    },
    width: 200
  },
  {
    Header: () => <FormattedMessage id="competency" defaultMessage="Competency" />,
    accessor: 'subAttribute',
    id: 'subAttribute',
    Cell: ({ cell: { value } }) => {
      const { color, backgroundColor } = getAttributeColors(value.attribute.name);
      return (
        <div
          className="custom-badge"
          style={{ '--badge-color': color, '--badge-background': backgroundColor } as CSSProperties}
        >
          {value.name}
        </div>
      );
    },
    width: 50
  }
];

export const filterData = (data: IQuestionWithOwner[], search: string, subAttributeIds: string[]) => filter(
  ({ text, subAttribute }) => {
    const searchMatching = (!search.trim()
      || searchByWords(search, text)
      || searchByWords(search, subAttribute?.name as string)
    );
    const attributesMatching = !subAttributeIds.length || any(id => id === subAttribute?.id, subAttributeIds);

    return searchMatching && attributesMatching;
  },
  data
);
